const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

const stats = [
  { value: "80%", label: "de mujeres se exponen al VPH en algún momento de su vida" },
  { value: "95%", label: "de casos de cáncer cervical son prevenibles con detección temprana" },
  { value: "1 de 4", label: "mujeres tiene el VPH sin saberlo" },
];

export default function EducationSection() {
  return (
    <section className="py-14 md:py-24 bg-teal-50/60">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <span
              className="inline-block text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-4"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Infórmate
            </span>
            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-5"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              ¿Qué es el VPH y por qué{" "}
              <span className="italic font-normal text-teal-600" style={{ fontFamily: "'Lora', serif" }}>
                importa detectarlo a tiempo?
              </span>
            </h2>
            <p
              className="text-slate-600 text-sm md:text-base leading-relaxed mb-4"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              El <strong>Virus del Papiloma Humano (VPH)</strong> es la infección de transmisión sexual más común en el mundo. Aunque en muchos casos desaparece solo, ciertos tipos de VPH de alto riesgo pueden causar lesiones en el cuello uterino que, sin tratamiento, pueden derivar en cáncer cervicouterino.
            </p>
            <p
              className="text-slate-600 text-sm md:text-base leading-relaxed mb-7"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              La buena noticia: con un <strong>Papanicolaou regular y una colposcopia cuando se requiere</strong>, estas lesiones pueden detectarse en etapas muy tempranas y tratarse de forma efectiva. La prevención a tiempo puede salvar vidas.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 mb-7">
              {stats.map((s) => (
                <div key={s.value} className="bg-white rounded-xl p-4 md:p-5 border border-teal-100">
                  <p
                    className="text-xl md:text-2xl font-bold text-teal-600 mb-1"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {s.value}
                  </p>
                  <p
                    className="text-slate-500 text-xs leading-relaxed"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {s.label}
                  </p>
                </div>
              ))}
            </div>

            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-7 py-3.5 rounded-full transition-all text-sm whitespace-nowrap cursor-pointer w-full sm:w-auto"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-whatsapp-line"></i>
              Agenda tu consulta hoy
            </a>
          </div>

          {/* Video + Image */}
          <div className="flex flex-col gap-5">
            {/* YouTube embed */}
            <div className="rounded-2xl overflow-hidden border border-teal-100">
              <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src="https://www.youtube.com/embed/ClSlwGzo47w"
                  title="Video educativo sobre VPH y colposcopia - Dr. Erick Tejada"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  aria-label="Video educativo sobre el VPH y prevención del cáncer cervical"
                />
              </div>
            </div>

            {/* Info card */}
            <div className="bg-white rounded-2xl p-5 md:p-6 border border-teal-100 flex items-start gap-4">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-emerald-100 flex-shrink-0">
                <i className="ri-calendar-check-line text-emerald-600 text-lg md:text-xl"></i>
              </div>
              <div>
                <h4
                  className="font-semibold text-slate-800 text-sm mb-1"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  ¿Cada cuánto debo hacerme un Pap?
                </h4>
                <p
                  className="text-slate-500 text-sm leading-relaxed"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Se recomienda realizarse el Papanicolaou cada año a partir de los 21 años o al inicio de la vida sexual. Consulta con el Dr. Tejada cuál es el esquema ideal para ti.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
